var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "collapsible",
      class: {
        "collapsible--collapsed": !_vm.isOpen
      }
    },
    [
      _c(
        "div",
        { staticClass: "collapsible__trigger", on: { click: _vm.toggle } },
        [_vm._t("trigger", null, { isOpen: _vm.isOpen })],
        2
      ),
      _vm._v(" "),
      _c("div", { ref: "content", staticClass: "collapsible__content" }, [
        _c(
          "div",
          { staticClass: "collapsible__content-wrapper" },
          [
            _vm._t("default", null, {
              isOpen: _vm.isOpen,
              open: _vm.open,
              close: _vm.close,
              toggle: _vm.toggle
            })
          ],
          2
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }